<template>
<div class="page-container">
    <div class="columns is-multiline">
        <div v-show="loading" class="column is-full has-text-centered">
            <img src="/loader-dark.svg">
        </div>
        <div v-show="error" class="column is-full">
            <div class="columns">
                <div class="column is-1">
                    <img width="100px" :src="require('@/assets/img/servers.svg')" />
                </div>
                <div class="column is-10">
                    <p class="default-settings-title">Connection failed</p>
                    <p class="default-settings-description">
                        <span v-if="error == 'access_denied'">
                            Looks like you refused to authorize Weap. Go to the <router-link :to="{ name: 'dashboard' }">Dashboard</router-link> and select the just created account to try again.
                        </span>
                        <span v-if="error == 'not_unique'">
                            This DigitalOcean account is already associated to a Weap.io account. It can't be associated again.
                        </span>
                        <span v-if="error == 'general_error'">
                            Something wrong happened and we haven't been able to connect to your DigitalOcean account. Go to the <router-link :to="{ name: 'dashboard' }">Dashboard</router-link> and select the just created account to try again.
                            If the error persists, please contact us.
                        </span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Api from '@/api';

export default {
    data() {
        return {
            loading: true,
            error: '',
        }
    },

    mounted() {
        if (this.$route.query.error == 'access_denied') {
            localStorage.removeItem('accountPendingAssociation');
            this.error = 'access_denied';
            this.loading = false;
            return;
        }
        this.sendAuthorizationCode();
        // console.log(this.$route.query.code);
    },

    methods: {
        sendAuthorizationCode() {

            // Check if the account pending the association exists in localStorage
            if (localStorage.accountPendingAssociation === null) {
                this.error = 'general_error';
                this.loading = false;
                return; // How to handle? Show a list of not associated accounts and select the one wanted?
            }

            if (!this.isJson(localStorage.accountPendingAssociation)) {
                localStorage.removeItem('accountPendingAssociation');
                this.error = 'general_error';
                this.loading = false;
                return; // Handle like the previous situation
            }

            let account = JSON.parse(localStorage.accountPendingAssociation);

            if (!account.id) {
                localStorage.removeItem('accountPendingAssociation');
                this.error = 'general_error'; // Handle like the previous situation
                this.loading = false;
                return;
            }

            let endpoint = 'accounts/' + account.id + '/authorization';

            let associationData = {
                authorization_code: this.$route.query.code,
                provider_slug: 'digital_ocean',
            };

            Api().put(endpoint, associationData)
                .then(response => {
                    this.$router.push({ name: 'dashboard' });
                })
                .catch(error => {
                    if (typeof error.response.data !== 'undefined' && typeof error.response.data.reason) {
                        this.error = error.response.data.reason;
                        this.loading = false;
                    } else {
                        this.error = 'general_error';
                        this.loading = false;
                    }
                })
                .finally(() => {
                    //
                });
        },

        isJson(text) {
            try {
                JSON.parse(text);
            } catch (e) {
                return false;
            }
            return true;
        },
    },
}
</script>
